var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconReset = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 15a6 6 0 1 0-5.192-9.008L8 8.5l-7 2V3l2.223 1.747a8 8 0 1 1 .79 9.56c-.367-.414-.246-1.042.21-1.354.456-.312 1.072-.188 1.455.209A5.982 5.982 0 0 0 10 15Z",
  clipRule: "evenodd"
})));
export default SvgIconReset;